export default {
  async books () {
    return await fetchBooks();
  }
}

async function fetchBooks (cb) {
  // eslint-disable-next-line no-console
  await fetch(
    'https://mybook-test.herokuapp.com/books',
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      credentials: 'include'
    }
  ).then(cb);
}